import ImageLink from '../Links/ImageLink/ImageLink';
import { HOME } from 'constants/routes';
import LogoIcon from 'static/logo/logo.svg';
import LogoWithoutTextIcon from 'static/logo/logo1.svg';
import classes from './Logo.module.css';

export const Logo = () => (
   <div className={classes.logo}>
      <ImageLink href={HOME} src={LogoIcon} alt="Logo" />
   </div>
);

export const LogoWithoutText = () => (
   <div className={classes.logo}>
      <ImageLink href={HOME} src={LogoWithoutTextIcon} alt="Logo" />
   </div>
);
